export const hasPermission = (
  userRoles,
  userPermissions,
  requiredPermission
) => {
  const isSuperAdmin = userRoles.find((role) => role.name === "Super Admin");

  if (isSuperAdmin) {
    return true;
  }

  // Normaliza para array
  const requiredPermissions = Array.isArray(requiredPermission)
    ? requiredPermission
    : [requiredPermission];

  const hasPermission = requiredPermissions.some((required) =>
    userPermissions.some(
      (permission) => permission.name?.toLowerCase() === required?.toLowerCase()
    )
  );

  return hasPermission;
};

export const hasRole = (rolesName, rolesUser) => {
  return rolesUser.some((role) => rolesName.includes(role.name));
};
